/**
 * Medidas compartidas de los bloques de estado (vacío y error): mismo anillo,
 * mismos tamaños de texto y mismos huecos, para que "no hay nada" y "no se pudo
 * traer nada" ocupen exactamente el mismo espacio en la pantalla.
 */
export const STATE_SIZE_TOKENS = {
  sm: {
    container: "px-4 py-8",
    ring: "h-12 w-12",
    icon: "h-5 w-5",
    title: "text-sm",
    description: "max-w-xs text-xs",
    gapAfterRing: "mt-3",
    gapAfterTitle: "mt-1",
    gapAfterDesc: "mt-3",
  },
  md: {
    container: "px-6 py-14",
    ring: "h-16 w-16",
    icon: "h-7 w-7",
    title: "text-base",
    description: "max-w-sm text-sm",
    gapAfterRing: "mt-4",
    gapAfterTitle: "mt-1.5",
    gapAfterDesc: "mt-5",
  },
} as const;

export type StateSize = keyof typeof STATE_SIZE_TOKENS;
